import React from 'react';
import { SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { accountSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';

interface DetailTabProps {
  searchFieldState: SearchFieldState;
  searchFieldActions: SearchFieldActions;
}

const DetailTab = ({ searchFieldState, searchFieldActions }: DetailTabProps) => {
  return (
    <div className='space-y-3 p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-[150px] shrink-0 text-[13px]'>TK doanh thu</Label>
        <SearchField<TaiKhoan>
          name='revenueAccount'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          dialogTitle='Danh mục tài khoản'
          value={searchFieldState.revenueAccount?.code}
          relatedFieldValue={searchFieldState.revenueAccount?.name}
          onRowSelection={searchFieldActions.setRevenueAccount}
          className='w-100'
        />
      </div>
    </div>
  );
};

export default DetailTab;
